export default __webpack_public_path__ + "static/desktop_sizzle-e22216db6b1e8d3022d41d8427fafdf6.mp4";